import React from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaPhone } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function ContactBanner() {
  return (
    <section className="sec_pd py-5">
      <div className="row align-items-center  gap-3 gap-lg-0">
      <div className="col-lg-6">
        <div className='mb-3'>
        <h3 className="text-start mb-4  text-black border-bottom pb-2">Contact Us</h3>
          <div className="mb-3 d-flex align-items-center">
            <FaMapMarkerAlt className="me-2 text-black" />
            <p className="mb-0 text-black">Anachronistic Auction House<br />
            Building A1, Dubai Digital Park, Dubai Silicon Oasis, Dubai,<br /> United Arab Emirates</p>
          </div>
          <div className="mb-3 d-flex align-items-center">
            <FaEnvelope className="me-2 text-black" />
            <p className="mb-0 text-black">
              <a href="mailto:info@anachronisticauctionhouse.com">info@anachronisticauctionhouse.com</a>
            </p>

          </div>
          {/* <div className="d-flex align-items-center">
            <FaPhone className="me-2 text-black" />
            <p className="mb-0 text-black">+971 4 228 52 85</p>
          </div> */}
        </div>
          <form>
            <div className="row g-3">
              <div className="col-md-6">
                <label htmlFor="name" className="form-label text-black">Name</label>
                <input type="text" id="name" className="form-control" placeholder="Your name" required />
              </div>
              <div className="col-md-6">
                <label htmlFor="email" className="form-label text-black">Email</label>
                <input type="email" id="email" className="form-control" placeholder="Your email" required />
              </div>
              <div className="col-md-6">
                <label htmlFor="contact" className="form-label text-black">Contact</label>
                <input type="tel" id="contact" className="form-control" placeholder="Your phone number" required />
              </div>
              <div className="col-md-6">
                <label htmlFor="subject" className="form-label text-black">Subject</label>
                <input type="text" id="subject" className="form-control" placeholder="Subject" required />
              </div>
              <div className="col-12">
                <label htmlFor="issue" className="form-label text-black">Describe</label>
                <textarea id="issue" className="form-control" rows="4" placeholder="Describe Here" required></textarea>
              </div>
              <div className="col-12 text-end">
              <Link
                    to='/home'
                    className="btn  btn-golden-glass text-white  position-relative overflow-hidden border-0"
                  >
                    <div className=" d-flex justify-content-center align-items-center" >
                      <p className="m-0 text-black fw-bold button_name">
                      Submit
                      </p>
                    </div>
                  </Link>
                {/* <button type="submit" className="btn btn-warning text-white">Submit</button> */}
              </div>
            </div>
          </form>
        </div>
        <div className="col-lg-6 mb-4 mb-lg-0">
        <div className="mx-3">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.5078842629123!2d55.3773353!3d25.1185147!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f651744f87c83%3A0x55e8b5a24af052b4!2sIFZA%20Business%20Park%2C%20Building%20A1!5e0!3m2!1sen!2sin!4v1744886571016!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />

        </div>
        </div>
       
      </div>
    </section>
  );
}

export default ContactBanner;